export const VISIT_NAME = 'visit_trackingURL';
export const TRACKER_UNKNOWN_VALUE = 'unknown';
export const SAVE_CARD_CHECKBOX_LABEL_CHECKED = 'checked';
export const SAVE_CARD_CHECKBOX_LABEL_UNCHECKED = 'unchecked';
